import { graphql } from "react-relay";

export const RemoveAccountsMutation = graphql`
  mutation RemoveAccountsMutation($input: RemoveAccountsInput!) {
    removeAccounts(input: $input) {
      problems {
        message
      }
      removed {
        id @deleteRecord
      }
    }
  }
`;
